export default "__VITE_ASSET__C7BIv39T__"